import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CheckAuth } from './providers/check-auth.service';
import { CheckNotAuth } from './providers/check-notAuth.service';
import { CheckLang } from './providers/check-lang';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/signup',
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/authentication/welcome-page/welcome-page.module').then(m => m.WelcomePagePageModule),
    canLoad: [CheckNotAuth]
  },
  {
    path: 'account',
    loadChildren: () => import('./pages/inside-app/account/account.module').then(m => m.AccountModule),
    canLoad: [CheckAuth]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/authentication/login/login.module').then(m => m.LoginModule),
    canLoad: [CheckNotAuth, CheckLang]
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/authentication/signup/signup.module').then(m => m.SignUpModule),
    canLoad: [CheckNotAuth, CheckLang]
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/inside-app/tabs-page/tabs-page.module').then(m => m.TabsModule),
    canLoad: [CheckAuth]
    // loadChildren: () => import('./router/redirect routings/redirect.module').then(m => m.RedirectModule),
  },
  {
    path: 'languages-popover',
    loadChildren: () => import('./pages/languages-popover/languages-popover.module').then(m => m.LanguagesPopoverPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/authentication/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule),
    canLoad: [CheckNotAuth, CheckLang]
  },
  {
    path: 'terms',
    loadChildren: () => import('./pages/authentication/terms/terms.module').then( m => m.TermsPageModule),
    canLoad: []
  },
  {
    path: 'i/:id/:token',
    loadChildren: () => import('./pages/authentication/auto-redirect/auto-redirect.module').then( m => m.AutoRedirectPageModule)
  },
  {
    path: 'v/:id/:token',
    loadChildren: () => import('./pages/authentication/auto-redirect/auto-redirect.module').then( m => m.AutoRedirectPageModule)
  },
  {
    path: 'a/:id/:token',
    loadChildren: () => import('./pages/authentication/auto-redirect/auto-redirect.module').then( m => m.AutoRedirectPageModule)
  },
  {
    path: 'poll-modal',
    loadChildren: () => import('./pages/inside-app/poll-modal/poll-modal.module').then( m => m.PollModalPageModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
